import React from 'react'

import icon from '../assets/icon.png'
import { Link } from 'react-router-dom'

export default function HeaderOption() {
  return (
    <div className='fixed z-10 flex items-center justify-between w-full p-3 max-lg:p-1 bg-[#fff] shadow-lg'>
      <div className="flex flex-wrap items-center justify-start md:gap-4 max-md:gap-2">
        <Link to={'/'} className='flex items-center gap-2'>
          <img src={icon} alt="" width={'50px'} className='select-none' />
          <p className='text-2xl font-semibold'>Last Car Zone</p>
        </Link>
        <div className="relative">
          <input type="search" id="default-search" className="block w-[320px] h-10 px-4 text-sm text-gray-900 border border-gray-300 rounded-full outline-none bg-gray-50 " placeholder="Search Car..." required />
          <button type="submit" className="text-white absolute right-0 bottom-2.5 pl-10  focus:outline-none  font-medium rounded-lg text-sm px-4 "> <svg aria-hidden="true" className="w-5 h-5 text-gray-500 " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg></button>
        </div>
      </div>
      <div className='flex items-center gap-4'>
        <Link to={'/cars'} className="relative inline-flex items-center p-1 text-sm font-medium text-center text-white border-2 rounded-full hover:bg-gray-200">
          <svg className='w-5 h-5' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z" fill="#596780" />
          </svg>
          <span className="sr-only">Notifications</span>
          <div className="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-red-500 border-2 border-white rounded-full -top-2 -right-2 ">
            3
          </div>
        </Link>
        <Link to={'/cars'} className="relative inline-flex items-center p-1 text-sm font-medium text-center text-white border-2 rounded-full hover:bg-gray-200">
          <svg className='w-5 h-5' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 0.75H1C0.447715 0.75 0 1.19772 0 1.75V2.25C0 2.80228 0.447715 3.25 1 3.25H3.0119L5.73626 14.7312C6.18267 16.6125 7.84065 17.9508 9.76471 17.9987V18H17.5874C19.5362 18 21.2014 16.5956 21.5301 14.6747L22.7857 7.33734C22.9947 6.11571 22.0537 5 20.8143 5H5.99657L5.21623 1.7114C5.08251 1.14787 4.57918 0.75 4 0.75Z" fill="#596780" />
            <path d="M10 21C10 22.1046 9.10457 23 8 23C6.89543 23 6 22.1046 6 21C6 19.8954 6.89543 19 8 19C9.10457 19 10 19.8954 10 21Z" fill="#596780" />
            <path d="M21 21C21 22.1046 20.1046 23 19 23C17.8954 23 17 22.1046 17 21C17 19.8954 17.8954 19 19 19C20.1046 19 21 19.8954 21 21Z" fill="#596780" />
          </svg>
          <span className="sr-only">Notifications</span>
          <div className="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-red-500 border-2 border-white rounded-full -top-2 -right-2 ">
            2
          </div>
        </Link>
        <div className="dropdown dropdown-end">
          <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
            <div className="w-10 rounded-full">
              <img src="https://www.nzherald.co.nz/resizer/sLDj54v6mBmfljZa9s1py-m9cJM=/576x613/filters:focal(1327x18:1903x632)/cloudfront-ap-southeast-2.images.arcpublishing.com/nzme/4B4ALEPEEVD3TN76KTWF43A5ZM.JPG" />
            </div>
          </label>
          <ul tabIndex={0} className="p-2 mt-3 shadow menu menu-compact dropdown-content bg-base-100 rounded-box w-52">
            <li>
              <a className="justify-between">
                Profile
                <span className="badge">New</span>
              </a>
            </li>
            <li><a>Settings</a></li>
            <li><a>Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  )
}
